export default {
  year: '年',
  month: '月',
  week: '周',
  weeks: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
  day: '日',
  hour: '时',
  minute: '分',
  second: '秒',
  am: '上午',
  pm: '下午',
};
